<template>
  <div class="modular">
    <div class="radiobox">
      <div class="radio">
        <el-radio v-model="radio" :label="1">柱状图</el-radio>
      </div>
    </div>
    <div v-show="radio === 1" v-loading="chartLoading">
      <div ref="modularChild10" class="echarts"></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { constKey, constArryOrder, constChildArryOrder } from '../selectOption';
import * as echarts from "echarts"
export default {
  name: 'modularChild10',
  props: ['socUserName'],
  data() {
    return {
      radio: 1,
      chartsi: null,
      chartLoading: false,
      optioni: {
        legend: {},
        tooltip: {},
        dataset: {
          dimensions: [],
          source: [
            // {
            //   product: "9月",
            //   "第一周": 43.3,
            //   "第二周": 85.8,
            //   "第三周": 93.7
            // },
            // { product: "10月", "第一周": 83.1, "第二周": 73.4, "第三周": 55.1 },
            // {
            //   product: "11月",
            //   "第一周": 86.4,
            //   "第二周": 65.2,
            //   "第三周": 82.5
            // },
            // {
            //   product: "12月",
            //   "第一周": 72.4,
            //   "第二周": 53.9,
            //   "第三周": 39.1
            // }
          ]
        },
        xAxis: { type: "category" },
        yAxis: {},
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: []
      },
    username:""
    };
  },
  methods: {
    getData(socUserName) {
      if (socUserName === undefined) {
        socUserName = this.socUserName
      }
      this.chartLoading = true;
      // let res = this.formatterData()
      // this.chartsi.setOption(this.optioni)
      let params = {
        "username": socUserName,
      }
      this.$http.post(`/front/consumer/order/soc/interface/queryAlarmNumber`, params)
        .then(data => {
          if (data && data.status === 200 && data.data.code === 0) {
            let res = this.formatterData(data.data.data)
            this.chartsi.setOption(this.optioni)
            //this.dataList = res
          } else {
            this.$message.error(data.result.msg)
          }
          this.chartLoading = false
        })
        .catch(() => {
          this.chartLoading = false
        })
      // this.chartsi.setOption(this.optioni)
    },
    formatterData(data) {
      data = {
        "monthly": {
            "value": data.monthly.value,
            "last": data.monthly.last,
            "inc": data.monthly.inc,
            "unprocessed": data.monthly.unprocessed,
            "processed": data.monthly.processed,
        },
        "weekly": {
            "value": data.weekly.value,
            "last": data.weekly.last,
            "inc": data.weekly.inc,
            "unprocessed": data.weekly.unprocessed,
            "processed": data.weekly.processed,
        }
    }
      // 将key替换成汉字
      data = this.replaceKeys(data)
      this.optioni.dataset.dimensions = ['product']
      this.optioni.dataset.source = []
      this.optioni.series = []
      // 汉字排序后插入option
      Object.keys(data).sort(function(a, b) {
        return constArryOrder[a] - constArryOrder[b]
      }).forEach((item, index) => {
        if (index === 0 && data[item]) {
          Object.keys(data[item]).sort(function(a, b) {
            return constChildArryOrder[a] - constChildArryOrder[b]
          }).forEach(i => {
            this.optioni.series.push({ type: "bar" })
            this.optioni.dataset.dimensions.push(i)
          })
        }
        this.optioni.dataset.source.push({
          ...data[item],
          product: item
        })
      })
      return this.optioni
    },
    replaceKeys(data) {
      if (typeof data === 'object') {
        Object.keys(data).forEach(item => {
          if (typeof data[item] === 'object') {
            data[constKey[item]] = this.replaceKeys(data[item])
            delete data[item]
          } else {
            data[constKey[item]] = data[item]
            delete data[item]
          }
        })
      } else {
        data[constKey[item]] = data[item]
        delete data[item]
      }
      return data
    }
  },
  mounted() {
    let charti = echarts.getInstanceByDom(this.$refs["modularChild10"]);
    if (charti === undefined) {
      this.chartsi = echarts.init(this.$refs["modularChild10"]);
      this.$once("hook:beforeDestroy", function() {
        echarts.dispose(this.chartsi);
      });
    }
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.modular {
  position: relative;
  .radiobox {
    pointer-events: none;
    width: 100%;
    position: absolute;
    top: -30px;
    .radio {
      pointer-events: auto;
      width: 100px;
      margin: 0 auto;
    }
  }
  .echarts {
    height: calc(100vh - 370px);
  }
}
</style>